import React, { FC, ReactElement, MouseEvent } from 'react'

import './OverlayComponent.scss'

interface IOverlayComponentProps {
  children: ReactElement
  open: boolean
  onClose: () => void
  id?: string
}

const OverlayComponent: FC<IOverlayComponentProps> = ({ children, open, onClose, id }) => {
  const handleStopPropagation = (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    e.stopPropagation()
  }

  return (
    <div id={id} className={`overlay-component--layout ${open ? 'overlay-component--open' : ''}`} onClick={onClose}>
      <div onClick={handleStopPropagation} className="overlay-component--content">
        {children}
      </div>
    </div>
  )
}

export default OverlayComponent
